import React from 'react';
import { ChildrenProp, ClassNameProp } from '../common-types';

/**
 * Props for a {@link DocumentList} component. The children are meant to be {@link Document} components.
 * @author agd
 */
export type DocumentListProps = Required<ChildrenProp> & ClassNameProp;

/**
 * Component meant for displaying a list of {@link Document}s.
 *
 * @param props a {@link DocumentListProps} object. The children are meant to be {@link Document} components.
 * @constructor
 * @return the created {@link JSX.Element}
 */
export function DocumentList({
  children,
  className = ''
}: DocumentListProps): JSX.Element {
  return (
    <div className={`ehs-document-list ${className}`.trim()}>{children}</div>
  );
}
